var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H26C31.5228 0 36 4.47715 36 10V26C36 31.5228 31.5228 36 26 36H10C4.47715 36 0 31.5228 0 26V10Z",
    fill: "#EEF2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6666 14.8522L18 18.0004M18 18.0004L12.3333 14.8522M18 18.0004L18 24.3337M24 20.7061V15.2947C24 15.0663 24 14.952 23.9663 14.8502C23.9366 14.7601 23.8879 14.6773 23.8236 14.6075C23.7509 14.5286 23.651 14.4732 23.4514 14.3622L18.518 11.6215C18.329 11.5165 18.2344 11.4639 18.1343 11.4434C18.0457 11.4251 17.9543 11.4251 17.8657 11.4434C17.7656 11.4639 17.6711 11.5165 17.482 11.6215L12.5486 14.3622C12.349 14.4732 12.2491 14.5286 12.1764 14.6075C12.1121 14.6773 12.0634 14.7601 12.0337 14.8502C12 14.952 12 15.0663 12 15.2947V20.7061C12 20.9345 12 21.0487 12.0337 21.1506C12.0634 21.2407 12.1121 21.3234 12.1764 21.3932C12.2491 21.4721 12.349 21.5276 12.5486 21.6385L17.482 24.3793C17.6711 24.4843 17.7656 24.5368 17.8657 24.5574C17.9543 24.5756 18.0457 24.5756 18.1343 24.5574C18.2344 24.5368 18.329 24.4843 18.518 24.3793L23.4514 21.6385C23.651 21.5276 23.7509 21.4721 23.8236 21.3932C23.8879 21.3234 23.9366 21.2407 23.9663 21.1506C24 21.0487 24 20.9345 24 20.7061Z",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16L15.5 13",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.2a3d9fec88a64fafb170804bfd179ded.svg";
export { ForwardRef as ReactComponent };